/* @generated */
import tokens from "../design-tokens/dist/dig/index.module.esm.js";
import { spacing } from "./spacing.esm.js";
import { typography } from "./typography.esm.js";
import { motion } from "./motion.esm.js";
import { utilities } from "./utilities.esm.js";
const vars = {
  ...tokens,
  Spacing: spacing,
  Type: typography,
  Motion: motion,
  Utilities: utilities
};
export {
  vars
};
